import React, { useEffect, useState} from "react";
import ListItem from "../../../components/ListItem";
import t from "../../../helpers/t";
import {moment} from '../../../../../vendor';
import { Biscuit } from "../../../../utils";
import { salesBillingsActions, useSelector } from 'inbooma-api';
 
 const SalesBillingsList = (props) => {

    const salesBillingsData = [];
    const [deletePending,setDeletePending] = useState(null);
     const [replacePending,setReplacePending] = useState(null);
    const _deleteSalesBilling = useSelector(state => state.sales_billings_data.deleteSalesBillings);
     const _replaceSalesBilling = useSelector(state => state.sales_billings_data.replaceSalesBillings);

    useEffect(() => {

        if (deletePending === null) return;

        if (_deleteSalesBilling.success === true) {
            props.removeItem(deletePending);
            // show notification
        } else {
            // show notification
        }
        setDeletePending(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_deleteSalesBilling]);

     useEffect(() => {

         if (replacePending === null) return;

         if (_replaceSalesBilling.success === true) {

             // show notification
         } else {
             // show notification
         }
         setReplacePending(null);
         // eslint-disable-next-line react-hooks/exhaustive-deps
     },[_replaceSalesBilling]);

    const fillData = () => {
        if (typeof props.salesBillings === "undefined") return;

        let billing, hasAccInvoice, hasWalletTransaction,hasPayment = false,clientInvoice =  false;
        for (let i=0;i<props.salesBillings.length;i++) {
            billing = props.salesBillings[i];
            hasWalletTransaction = typeof billing.wallet_transactions !== 'undefined' && billing.wallet_transactions;
            if(hasWalletTransaction){
                billing.wallet_transactions.map(wt => {
                    if(wt.online && wt.payment_status === 'PAID' && wt.credit > 0){
                        hasPayment = wt.payment_date;
                    }
                })
            }
            hasAccInvoice = true;
            clientInvoice = (hasAccInvoice && billing.user_id === null);
            let locationName = "", userName= "";
            if (hasAccInvoice || billing.client_id === 7) {
                if(billing.location_id !== null && typeof billing.location.name !== 'undefined'){
                    locationName = billing.location.name;
                }
                if(billing.user_id !== null && typeof billing.user.last_name !== 'undefined'){
                    userName = " (" + billing.user.last_name + ", " + billing.user.first_name + ")";
                }
                salesBillingsData.push({
                    elements: [{
                        type: "text",
                        value: "begin" + " - " + "end" + userName + locationName,
                        title: "",
                        data: [{
                            value: "begin" + " - " + "end",
                            text: locationName !== ""?locationName + " "+moment(billing.begin).format('MMMM YYYY'):moment(billing.begin).format('DD.MMMM YYYY') + ' - ' + moment(billing.end).format('DD.MMMM YYYY'),
                            extraClasses: "text-small",
                            title: t('service period', null, 'capital'),
                        }],
                        mediumWidth: 3,
                        smallWidth: 3,
                        handler: onItemClickedHandler
                    }, {
                        type: "text",
                        value: "invoice_nbr_major",
                        title: "",
                        data: [{
                            value: "invoice_nbr_major",
                            text: hasAccInvoice ? billing.invoice_nbr_major : "",
                            extraClasses: "text-small",
                            title: t('invoice_nbr', null, 'capital')
                        }],
                        mediumWidth: 1,
                        smallWidth: 1,
                        handler: onItemClickedHandler
                    }, {
                        type: "text",
                        value: "created",
                        title: "",
                        data: [{
                            value: "created",
                            text:  billing.modified !== null ? moment(billing.modified).format('dd, DD.MM.YYYY'): (billing.created !== null ? moment(billing.created).format('dd, DD.MM.YYYY') : ""),
                            extraClasses: "text-small",
                            title: t('invoice_date', null, 'capital')
                        }],
                        mediumWidth: 2,
                        smallWidth: 2,
                        handler: onItemClickedHandler
                    },
                        {
                            type: "text",
                            value: "payment_date",
                            title: "",
                            data: [{
                                value: "payment_date",
                                text: hasPayment !== false ? moment(hasPayment).format('dd, DD.MM.YYYY') : "",
                                extraClasses: "text-small",
                                title: t('payment_date', null, 'capital')
                            }],
                            mediumWidth: 2,
                            smallWidth: 2,
                            handler: onItemClickedHandler
                        }, {
                        type: "text",
                        value: "status",
                        title: "",
                        data: [{
                            value: "status",
                            text: hasAccInvoice && !clientInvoice ? t(billing.status) : "",
                            extraClasses: "text-small",
                            title: t('status', null, 'capital')
                        }],
                        mediumWidth: 2,
                        smallWidth: 2,
                        handler: onItemClickedHandler
                    }, {
                        type: "text",
                        value: "file_" + billing.id,
                        title: billing.file,
                        extraTopClasses: "text-small",
                        data: [{
                            value: "file_" + billing.id,
                            text: "",
                            icon: "fi fi-page",
                            ref: "#",
                            title: billing.file,
                            handler: onItemClickedHandler
                        }],
                        mediumWidth: 1,
                        smallWidth: 1,
                        handler: onItemClickedHandler
                    },
                        Biscuit.get('user.is_superuser')  === 'true'  ?{
                        type: "text",
                        value: "replace_" + billing.id,
                        title: t('replace'),
                        extraTopClasses: "text-small",
                        data: [{
                            value: "replace_" + billing.id,
                            text: "",
                            icon: "fi fi-refresh",
                            ref: '#',
                            title: t('replace')
                        }],
                        mediumWidth: 1,
                        smallWidth: 1,
                        handler: onItemClickedHandler
                    }:{}
                    ]
                });

            }
        }
    };



    const onItemClickedHandler = (value) => {


        if (value.startsWith("file_")) {

            const id = parseInt(value.split("file_")[1]);

            for (let i=0;i<props.salesBillings.length;i++) {
                if (parseInt(props.salesBillings[i].id) === id) {
                    console.log("open file: ", props.salesBillings[i].name);
                    props._readFile(props.salesBillings[i]);
                    break;
                }
            }
        }

        if (value.startsWith("delete_")) {
            const id = parseInt(value.split("delete_")[1]);

            for (let u=0;u<props.salesBillings.length;u++) {
                if (parseInt(props.salesBillings[u].id) === id) {
                    console.log("delete file: ", props.salesBillings[u].name);
                    if (confirm(t('really_remove'))) {
                        props.dispatch(salesBillingsActions.deleteSalesBillings({
                            token: Biscuit.get('token'),
                            id: id
                        }));
                        setDeletePending(id);
                    }
                    break;
                }
            }
        }
        if (value.startsWith("replace_")) {
            const id = parseInt(value.split("replace_")[1]);

            for (let i=0;i<props.salesBillings.length;i++) {
                if (parseInt(props.salesBillings[i].id) === id) {
                    console.log("replace file: ", props.salesBillings[i].name);
                    if (confirm(t('really_remove'))) {
                        props.dispatch(salesBillingsActions.replaceSalesBillings({
                            token: Biscuit.get('token'),
                            id: id
                        }));
                        setReplacePending(id);
                    }
                    break;
                }
            }
        }
    };



    fillData();

    return (
        <div className='inb-c-listing'>
        {typeof props.salesBillings !== 'undefined' && props.salesBillings.map((salesBilling, index) => {
            return (
                <ListItem
                    key={"sbi-" + index}
                    listStyle="tight"
                    id={"sales-billings-item-" + index}
                    elements={salesBillingsData[index].elements}/>
            )})}
        </div>
    );
 };
 export default SalesBillingsList;